import React from 'react'

type Props = { children: React.ReactNode }
type State = { hasError: boolean, error?: any }

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props){
    super(props)
    this.state = { hasError: false }
  }
  static getDerivedStateFromError(error: any){
    return { hasError: true, error }
  }
  componentDidCatch(error: any, info: any){
    console.error('UI ErrorBoundary caught', error, info)
  }
  render(){
    if (this.state.hasError){
      return <div className="card"><h2 className="font-semibold text-red-700">Something went wrong.</h2><pre className="text-xs whitespace-pre-wrap">{String(this.state.error)}</pre></div>
    }
    return this.props.children
  }
}

